import clsx from 'clsx';
import { type ElementType, type HTMLAttributes, type ReactNode, forwardRef } from 'react';

export type TextVariant =
  | 'display-xxl'
  | 'display-xl'
  | 'display-l'
  | 'display-m'
  | 'display-s'
  | 'display-xs'
  | 'body-l'
  | 'body-m'
  | 'body-s'
  | 'body-xs'
  | 'mono-m'
  | 'mono-s'
  | 'numeric-m'
  | 'numeric-l';

export type TextTone = 'primary' | 'soft' | 'whisper' | 'coral' | 'leaf' | 'ember';

export interface TextProps extends HTMLAttributes<HTMLElement> {
  as?: ElementType;
  variant?: TextVariant;
  tone?: TextTone;
  children: ReactNode;
}

export const Text = forwardRef<HTMLElement, TextProps>(function Text(
  { as: Tag = 'p', variant = 'body-m', tone = 'primary', className, children, ...rest },
  ref,
) {
  return (
    <Tag
      ref={ref}
      className={clsx('perch-text', className)}
      data-variant={variant}
      data-tone={tone}
      {...rest}
    >
      {children}
    </Tag>
  );
});
